var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11 0C5.20101 0 0.5 4.70101 0.5 10.5C0.5 16.299 5.20101 21 11 21C16.799 21 21.5 16.299 21.5 10.5C21.5 4.70101 16.799 0 11 0ZM11.7175 10.5574V16.2699H9.35392V10.5576H8.17308V8.58902H9.35392V7.40709C9.35392 5.80113 10.0207 4.84615 11.9151 4.84615H13.4922V6.81495H12.5064C11.769 6.81495 11.7202 7.09006 11.7202 7.6035L11.7175 8.58879H13.5034L13.2944 10.5574H11.7175Z","fill":"black"}));
}

Facebook.defaultProps = {"width":"22","height":"21","viewBox":"0 0 22 21","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
